<template>
  <div class="container">
    <img class="banner" src="../../../assets/img/guide/secure.png" />
    <div class="content">
      <h3 class="subTitle">如何使用？</h3>
      <div class="progress">
        <div>
          <span class="no">1</span>
          <span class="des">选择文件</span>
        </div>
        <div class="dottedCon">
          <span class="dotted" />
        </div>
        <div>
          <span class="no">2</span>
          <span class="des">走到打印机面前</span>
        </div>
        <div class="dottedCon">
          <span class="dotted" />
        </div>
        <div>
          <span class="no">3</span>
          <span class="des">扫描打印机快印码，开始打印</span>
        </div>
      </div>
      <h3 class="subTitle">找不到快印码？</h3>
      <p class="text" style="margin: 15px 0">
        您可以在智慧打印小程序，客户端，web端找到快印码并打印。若您是企业的成员用户，可通知管理员找
        到快印码并打印
      </p>
      <h3 class="subTitle">1、智慧打印小程序</h3>
      <p class="text">
        设备-》设备管理-》选择打印机-》打印快印码
      </p>
      <div class="imgContainer">
        <div class="a3-1 commonImg">
          <PreViewImage :src="require('../../../assets/img/guide/3-1.png')" />
        </div>
        <div class="a3-2 commonImg">
          <PreViewImage :src="require('../../../assets/img/guide/3-1.png')" />
        </div>
      </div>
      <h3 class="subTitle">2、智慧打印客户端</h3>
      <p class="text">
        设备-》设备管理-》选择打印机-》打印快印码
      </p>
      <PreViewImage
        class="imgTips commonImg mr50"
        :src="require('../../../assets/img/guide/3-3.png')"
      />
      <PreViewImage
        class="imgTips commonImg mr50"
        :src="require('../../../assets/img/guide/3-4.png')"
      />
      <h3 class="subTitle">3、web端</h3>
      <p class="text">
        福昕云办公官网-》我的工作台-》打印-》设备管理-》 选择打印机-》打印快印码
      </p>
      <PreViewImage
        class="imgTips commonImg mr50"
        :src="require('../../../assets/img/guide/3-5.png')"
      />
      <PreViewImage
        class="imgTips commonImg mr50"
        :src="require('../../../assets/img/guide/3-6.png')"
      />
      <PreViewImage
        class="imgTips commonImg mr50"
        :src="require('../../../assets/img/guide/3-7.png')"
      />
    </div>
  </div>
</template>

<script>
import PreViewImage from "common/components/app/PreViewImage.vue";

export default {
  components: {
    PreViewImage
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/guide.scss";

.container {
  padding: 0 !important;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
}

.banner {
  width: 100%;
  height: 300px;
}

.imgContainer {
  display: flex;
  margin-bottom: 60px;
  margin-top: 35px;
}

.content {
  width: 100%;
  padding: 55px;
}

.progress {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px 0 40px;
  & > div {
    display: flex;
    align-items: center;
  }
  .no {
    display: block;
    width: 32px;
    height: 32px;
    background-color: #0078ff;
    border-radius: 16px;
    color: white;
    font-size: 24px;
    margin-right: 18px;
    text-align: center;
    line-height: 32px;
  }
  .des {
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 1px;
    color: #666666;
  }
  .dottedCon {
    padding: 4px 0 4px 15px;
    .dotted {
      height: 29px;
      border-left: 1px dotted #0078ff;
    }
  }
}

.subTitle {
  font-size: 32px;
  font-stretch: normal;
  line-height: 51px;
  letter-spacing: 2px;
  color: #333333;
  font-weight: bold;
}

.text {
  font-family: MicrosoftYaHei;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 55px;
  letter-spacing: 1px;
  color: #666666;
}

.a3-1 {
  width: 303px;
  margin-right: 45px;
}

.a3-2 {
  width: 290px;
}

.imgTips {
  width: 638px;
}
</style>
